import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-screen flex flex-col overflow-hidden justify-center items-center relative papsi-loading-screen" }
const _hoisted_2 = { class: "flex flex-col items-center justify-center w-full px-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("img", {
      class: "papsi-mascot w-1/2 md:w-1/4 lg:w-1/6 mb-10",
      src: "https://resource.pafcpic.net/assets/pia/images/elements/papsi_kalabaw.png"
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-theme-primary text-5xl font-bold mb-2 flex items-center" }, "404 Error", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-gray-500 text-xl" }, "Sorry, page not found", -1)),
      _createVNode(_component_Button, {
        rounded: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/'))),
        button_text: "Back to Home",
        class: "mt-10 max-w-sm",
        theme: 'text-white'
      })
    ])
  ]))
}